import { createContext } from 'react';
import { IAppContextData } from 'interfaces/commons/IContext';

export const AppContext = createContext<IAppContextData>({} as IAppContextData);
